// extracted by mini-css-extract-plugin
module.exports = {"main":"_14RwN","termsList":"_3__D7","terms":"QqUi0","termsHeading":"Fca0b","orange":"_3kYML"};